<script>
export default {
  methods: {
    openInNewTab: (url) => window.open(url, '_blank')
  }
}
</script>